import React, { useEffect, useState } from 'react'
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'
import { BotonProcesar } from '../../components/buttons/BotonProcesar'
import { addDaysDate, classNameInput, dateFormatToString } from '../../../utils/utils'
import { useSeguimientoIncidencias } from '../../../hooks/AnaliticaYReportes/useSeguimientoIncidencias'
import { DatePickerABX } from '../../components/pickers/DatePicker'
import PantallaCargaInterna from '../../components/forms/PantallaCargaInterna'

export const SeguimientoIncidencias = () => {
  const [fechaInicio, setFechaInicio] = useState(addDaysDate(-1))
  const [fechaFin, setFechaFin] = useState(new Date())
  const [codEmpresaActual, setCodEmpresaActual] = useState(0)
  const [estaCargando, setEstaCargando] = useState(false)
  
  const hookSeguimientoIncidencias = useSeguimientoIncidencias()
  
  useEffect(() => {
    (async () => {
      await hookSeguimientoIncidencias.listarEmpresas()
      await listarTabla()
    })()
  },[])

  const listarTabla = async () => {
    setEstaCargando(true)
    await hookSeguimientoIncidencias.listarSeguimientosPorFecha(
      dateFormatToString(fechaInicio), 
      dateFormatToString(fechaFin),
      codEmpresaActual
    )
    setEstaCargando(false)
  }
  
  return (
    <>
      {estaCargando ? <PantallaCargaInterna></PantallaCargaInterna> : <></>}
      <ContenedorParametros titulo="Seguimiento de incidencias">
        <i className='fas fa-calendar'></i>
        <div>
          <DatePickerABX date={fechaInicio} setDate={setFechaInicio} ></DatePickerABX>
        </div>
        
        <i className='fas fa-calendar'></i>
        <div>
          <DatePickerABX date={fechaFin} setDate={setFechaFin} ></DatePickerABX>
        </div>

        <i className='fas fa-building'></i>
        <select name="" id="" value={codEmpresaActual} onChange={e => setCodEmpresaActual(e.target.value)} className={classNameInput}>
          <option value="0">--Todas las empresas--</option>
          {
            hookSeguimientoIncidencias.empresas.map((data,i) => <option key={i+1} value={data.codEmpresa}>{data.nomEmpresa}</option>)
          }
        </select>
        
        <BotonProcesar onClick={listarTabla}></BotonProcesar>
      </ContenedorParametros>

      <div className='flex-grow overflow-auto'>
        <table className='table'>
          <thead>
            <tr>
              <th className='w-[50px]'>Nº</th>
              <th>EMPRESA</th>
              <th>RUTA</th>
              <th>DESCRIPCIÓN</th>
              <th>F.CREACIÓN</th>
            </tr>
          </thead>
          <tbody>
            {
              hookSeguimientoIncidencias.seguimientosPorFecha.length != 0
              ? hookSeguimientoIncidencias.seguimientosPorFecha.map((data,i) => (
                <tr>
                  <td className='text-center'>{i+1}</td>
                  <td className='text-center'>{data.nomEmpresa || '-'}</td>
                  <td className='text-center'>{data.nomRuta || '-'}</td>
                  <td className='text-center'>{data.descripcion || '-'}</td>
                  <td className='text-center'>{data.fechaCreacion || '-'}</td>
                </tr>
              ))
              : <tr><td colSpan={5} className='text-center'>No hay información para mostrar...</td></tr>
            }
          </tbody>
        </table>
      </div>
    </>
  )
}
